import Vue from 'vue'
import vueMoment from 'vue-moment'
import VueAgile from 'vue-agile'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import VueUploadMultipleImage from 'vue-upload-multiple-image'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import gallery from 'img-vuer'
import vGallery from 'v-gallery'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
Vue.config.productionTip = false
Vue.prototype.$EventBus = new Vue()

const datepickerOptions = {
  dateLabelFormat: 'YYYY, MM D, dddd',
  days: ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일'],
  daysShort: ['월', '화', '수', '목', '금', '토', '일'],
  monthNames: [
    '1월',
    '2월',
    '3월',
    '4월',
    '5월',
    '6월',
    '7월',
    '8월',
    '9월',
    '10월',
    '11월',
    '12월'
  ],
  colors: {
    selected: '#ff6565',
    inRange: 'rgb(255, 219, 219)',
    text: '#403f3f',
    selectedText: '#403f3f',
    disabled: 'transparent',
    inRangeBorder: '#e4e7e7',
    hoveredInRange: 'rgb(255, 219, 219)'
  }
}

Vue.use(AirbnbStyleDatepicker, datepickerOptions)
Vue.use(vueMoment)
Vue.use(VueAgile)
Vue.use(gallery)
Vue.use(vGallery)
new Vue({
  router,
  store,
  datepickerOptions,
  VueUploadMultipleImage,
  vueMoment,
  VueAgile,
  BeatLoader,
  render: h => h(App)
}).$mount('#app')
